import React, { useState } from 'react';
import { TextField, Button, Container, Typography, Paper } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const AdminLogin = () => {
    const [admin, setAdmin] = useState({ username: '', password: '' });
    const [error, setError] = useState('');
    const navigate = useNavigate();

    const handleLogin = () => {
        axios({
            method: "POST",
            url: `${process.env.REACT_APP_MY_API}/api/auth/login`,
            data: {
                email: admin.username,
                password: admin.password
            }
        }).then((res) => {
            localStorage.setItem("token", res.data.token)
            navigate('/admin-dashboard');
        }).catch(() => {

            setError('Invalid credentials');
        })
    }


    return (
        <Container sx={{ mt: 5 }}>
            <Paper sx={{ p: 4, maxWidth: 400, mx: 'auto' }}>
                <Typography variant="h5" gutterBottom>Admin Login</Typography>
                <TextField
                    label="Username"
                    fullWidth
                    margin="normal"
                    value={admin.username}
                    onChange={(e) => setAdmin({ ...admin, username: e.target.value })}
                />
                <TextField
                    label="Password"
                    type="password"
                    fullWidth
                    margin="normal"
                    value={admin.password}
                    onChange={(e) => setAdmin({ ...admin, password: e.target.value })}
                />
                {error && <Typography color="error">{error}</Typography>}
                <Button variant="contained" fullWidth sx={{ mt: 2 }} onClick={handleLogin}>
                    Login
                </Button>
            </Paper>
        </Container>
    );
};

export default AdminLogin;
